import { Text } from '@mantine/core';
import { IconFileText } from '@tabler/icons-react';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';
import type { DocumentListItem } from '@/entities/DocumentList';

import s from './DocumentLinksList.module.scss';

type DocumentLinksListProps = {
  documents: DocumentListItem[];
  organizationId: string;
};

const DocumentLinksList: React.FC<DocumentLinksListProps> = ({ documents, organizationId }) => {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className={s.root__documents}>
      <ul className={s['root__documents-list']}>
        {documents.map((doc) => (
          <li key={doc.id} className={s['root__documents-item']}>
            <Link
              to={ROUTES.organization.documents.document.documentPreview.create(organizationId, doc.id)}
              className={s['root__document-link']}
            >
              <IconFileText size={16} className={s['root__documents-icon']} />
              <Text className={s.root__text} component="span">
                {doc.name}
              </Text>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default React.memo(DocumentLinksList);
